<template>
  <div class="integration-menu-entity-edit-page">
    <div class="integration-menu-entity-edit-page__banner" role="status">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <span>{{ $t('gestiune.integrationsMenuValidationEditPageHint') }}</span>
    </div>
    <component
      :is="entityComponent"
      v-if="entityComponent"
      :key="entityRouteKey"
      :route="entityRoute"
    />
  </div>
</template>

<script>
import ProductEdit from 'src/components/Dashboard/Views/Products/ProductEdit.vue'
import ProductOptionEdit from 'src/components/Dashboard/Views/ProductOptions/ProductOptionsEdit.vue'
import GroupOptionsEdit from 'src/components/Dashboard/Views/GroupOptions/GroupOptionsEdit.vue'

const ENTITY_COMPONENTS = Object.freeze({
  product: ProductEdit,
  'product-option': ProductOptionEdit,
  'group-option': GroupOptionsEdit
})

export default {
  name: 'IntegrationMenuEntityEditPage',
  components: {
    ProductEdit,
    ProductOptionEdit,
    GroupOptionsEdit
  },
  computed: {
    entityType () {
      const matched = this.$route.matched || []
      for (let i = matched.length - 1; i >= 0; i--) {
        const type = matched[i].meta && matched[i].meta.entityType
        if (type) return type
      }

      const segments = String(this.$route.path || '').split('/').filter(Boolean)
      const menuFixIdx = segments.indexOf('menu-fix')
      if (menuFixIdx >= 0 && segments[menuFixIdx + 1]) {
        const segment = segments[menuFixIdx + 1]
        if (segment === 'product') return 'product'
        if (segment === 'product-option') return 'product-option'
        if (segment === 'group-option') return 'group-option'
      }

      return null
    },
    entityComponent () {
      return ENTITY_COMPONENTS[this.entityType] || null
    },
    entityRoute () {
      return {
        params: { id: this.$route.params.id },
        query: { ...this.$route.query },
        path: this.$route.path,
        fullPath: this.$route.fullPath,
        name: this.$route.name
      }
    },
    entityRouteKey () {
      return `${this.entityType || 'unknown'}-${this.$route.params.id || ''}`
    }
  }
}
</script>

<style scoped>
.integration-menu-entity-edit-page {
  padding-top: 4px;
}
.integration-menu-entity-edit-page__banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 18px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #eef0fb;
  border: 1px solid #c5cae9;
  font-size: 13px;
  line-height: 1.5;
  color: #25396f;
}
.integration-menu-entity-edit-page__banner .fa-info-circle {
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 15px;
  color: #674bd2;
}
.integration-menu-entity-edit-page >>> .settings-top-bar {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/IntegrationMenuEntityEditPage.vue